import React from 'react'
import { Layout, SEO } from '../../../components'
import styled from 'styled-components'
import { media, Container, Row, Col } from 'styled-bootstrap-grid'
import imgSectionTitle1 from './section-title1.svg'
import imgSectionTitle2 from './section-title2.svg'
import imgSectionTitle3 from './section-title3.svg'
import imgSectionTitle4 from './section-title4.svg'
import { Navigation } from '../../../services'

const RECHARGE_LINK = `//${Navigation.PROFILE_HOST}/billing/recharge?user01cz`
const Bg = styled.div`
  background: #961b1e;
  color: #f7f3a6;
  font-size: 12px;
  a,
  a:visited,
  a:hover,
  a:active {
    color: inherit;
  }
  ${media.lg`
    font-size: 16px;
  `}
`
const StyledContainer = styled(Container)`
  ${media.lg`
    max-width: 780px;
  `}
`
const Title = styled.div`
  display: inline-block;
  width: 268px;
  height: 148px;
  margin-top: 60px;
  background: url('https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/m-banner-title-20210118.png')
    no-repeat left center / contain;
  ${media.lg`
    width: 910px;
    height: 250px;
    background: url('https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/banner-title-20210118.png')
      no-repeat left center / contain;
  `}
`
const Button = styled.a`
  width: 104px;
  height: 34px;
  background: #ffffff;
  box-shadow: 5px 2px 6px 0px #b10b0f;
  border-radius: 1000px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
  &&&,
  &&&:visited,
  &&&:hover,
  &&:active {
    color: #be2d30;
  }
  ${media.lg`
    width: 140px;
    height: 46px;
    font-size: 18px;
  `}
`
const BannerBg = styled.div`
  position: relative;
  width: 100vw;
  height: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #961b1e
    url('https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/m-banner-bg.png')
    no-repeat center center / cover;
  ${media.lg`
    width: 100%;
    height: 570px;
    background: #961b1e url('https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/banner-bg.png') no-repeat center center / cover;
  `}
`
const SectionTitle = styled.div`
  text-align: center;
  padding: 15px 0;
  img {
    max-width: 240px;
    height: auto;
  }
  ${media.lg`
    font-size: 18px;
  `}
`
const Card = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  margin-bottom: 15px;
  > img {
    width: 240px;
    height: 210px;
  }
  ${media.lg`
    > img {
      width: 320px;
      height: 290px;
    }
  `}
`
const Duration = styled.div`
  font-size: 17px;
  margin-top: 15px;
  img {
    width: 20px;
    height: 20px;
  }
  ${media.lg`
    font-size: 18px;
    margin-top: 30px;
  `}
`
const Arrow = styled.img.attrs(() => ({
  src: 'https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/arrow.png',
}))`
  width: 8px;
  height: 14px;
  position: relative;
  top: 14px;
  ${media.lg`
    width: 12px;
    height: 22px;
    top: 21px;
  `}
`
const StepCard = styled.div`
  font-size: 12px;
  min-height: 102px;
  text-align: center;
  img {
    width: 42px;
    height: 42px;
  }
  ${media.lg`
    font-size: 18px;
    img {
      width: 64px;
      height: 64px;
    }
  `}
`
const Steps = styled.div`
  display: flex;
  justify-content: space-between;
`
const Rules = styled.div`
  font-size: 12px;
  line-height: 20px;
  padding-bottom: 44px;
  p {
    margin: 0;
  }
  ${media.lg`
    font-size: 18px;
    line-height: 30px;
  `}
`

export default function Page20201224() {
  return (
    <Layout>
      <SEO
        title='双旦充值送精美好礼-青椒云'
        keywords='云桌面,云桌面促销'
        description='双旦充值送精美好礼. 活动时间2020年12月25日-2021年1月25日'
      />
      <Bg>
        <BannerBg>
          <Title></Title>
          <Button href={RECHARGE_LINK} target='_blank'>
            立即充值
          </Button>
        </BannerBg>

        <StyledContainer>
          <SectionTitle>
            <img src={imgSectionTitle1} alt='' />
          </SectionTitle>
          <Row justifyContent='center' alignItems='center'>
            <Col col={12} lg={6} alignSelf='center'>
              <Card href={RECHARGE_LINK} target='_blank'>
                <img
                  src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/card1.png'
                  alt=''
                />
              </Card>
            </Col>
            <Col col={12} lg={6} alignSelf='center'>
              <Card href={RECHARGE_LINK} target='_blank'>
                <img
                  src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/card2.png'
                  alt=''
                />
              </Card>
            </Col>
          </Row>

          <SectionTitle>
            <img src={imgSectionTitle2} alt='' />
            <Duration>
              <img
                src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/clock.png'
                alt=''
              />
              2020.12.25-2021.1.25
            </Duration>
          </SectionTitle>

          <SectionTitle>
            <img src={imgSectionTitle3} alt='' />
          </SectionTitle>
          <Steps>
            <StepCard>
              <img
                src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/step1.png'
                alt=''
              />
              <p>登录账号</p>
            </StepCard>
            <Arrow></Arrow>
            <StepCard>
              <img
                src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/step2.png'
                alt=''
              />
              <p>充值</p>
            </StepCard>
            <Arrow></Arrow>
            <StepCard>
              <img
                src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/step3.png'
                alt=''
              />
              <p>充值完成</p>
            </StepCard>
            <Arrow></Arrow>
            <StepCard>
              <img
                src='https://static-qingjiaocloud.oss-cn-shenzhen.aliyuncs.com/20201223/step4.png'
                alt=''
              />
              <p>
                满100元填写
                <br />
                礼物邮寄地址
              </p>
            </StepCard>
          </Steps>

          <SectionTitle>
            <img src={imgSectionTitle4} alt='' />
          </SectionTitle>
          <Rules>
            <p>1.本次活动充值金额仅限青椒云云电脑消费使用</p>
            <p>
              2.充值说明
              <br />
              （1）活动期间，新人立减券，充值满50元可用； <br />
              （2）充值、购买套餐实付金额满100及以上，即可获得青椒云定制礼品一份（限量100份）；
              <br />
              （3）活动礼品将在2020/12/25-2020/12/30充值完成的在12月31号寄出；2020/12/31-2021/1/12完成充值的在1月13号寄出；2021/1/13-2021/1/25完成充值的在1月26号寄出；礼品将会在以上三个时间段分别寄出，由于地区不同收到货的时间也会有所不同，若快递在寄出15天内还未收到请及时联系A君；
            </p>
            <p>3.本次活动最终解释权归瑞云所有。</p>
          </Rules>
        </StyledContainer>
      </Bg>
    </Layout>
  )
}
